import { render } from "./icon-error.svg?vue&type=template&id=06ba4f8f?inline"
const script = {}
script.render = render

export default script